import { AppThunk } from '../../../store/rootReducer';
import * as waveActions from '../actions/wave.actions';
import { waveForIdsSelector } from '../selectors/wave.selectors';
import { WaveId } from '../types/wave.type';

export const deleteWaves = (waveIds: WaveId[]): AppThunk => (
  dispatch,
  getState,
) => {
  const waves = waveForIdsSelector(waveIds)(getState());
  if (waves.length > 0) {
    const waveIds = waves.flatMap(({ id, link }) => {
      const ids = [id];
      if (link) {
        ids.push(link.waveId);
      }
      return ids;
    });

    dispatch(waveActions.remove({ waveIds }));
  }
};
